import { render } from "./EditOrganisationRole.vue?vue&type=template&id=eb618f8a"
import script from "./EditOrganisationRole.vue?vue&type=script&lang=js"
export * from "./EditOrganisationRole.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__